export default {
  pinkDark: '#3d003b',
  pink: '#c900c2',
  purpleDark: '#120a20',
  purple: '#673bb7',
  blueDark: '#00122f',
  blue: '#0d47a1',
  turquoiseDark: '#01334a',
  turquoise: '#00b0ff',
  white: '#fff',
  gray: '#aeaeae',
  black: '#000',
  blackDark: '#191919',
  cyanDark: '#2B91A5',
};



// WEBPACK FOOTER //
// ./src/theme/colors.js